const instances = new Map();
const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
function mount(scope = document) {
  for (const section of scope.querySelectorAll('[data-r6-reviews]')) {
    if (instances.has(section)) continue;
    const controller = new AbortController();
    const cards = Array.from(section.querySelectorAll('[data-r6-review-card]'));
    const buttons = Array.from(section.querySelectorAll('[data-r6-review-filter]'));
    const count = section.querySelector('[data-r6-review-count]');
    const empty = section.querySelector('[data-r6-review-empty]');
    function filter(value) {
      let shown = 0;
      for (const card of cards) {
        const topics = (card.dataset.r6ReviewTopics || '').split(',').map((topic) => topic.trim());
        const matches = value === 'all' || (value === 'photo' && card.dataset.r6ReviewPhoto === 'true') || (value === 'pack3' && card.dataset.r6ReviewPack.includes('3meses')) || topics.includes(value);
        card.hidden = !matches;
        if (matches) shown++;
      }
      for (const button of buttons) button.setAttribute('aria-pressed', String(button.dataset.r6ReviewFilter === value));
      count.textContent = String(shown);
      if (empty) empty.hidden = shown !== 0;
    }
    for (const button of buttons) button.addEventListener('click', () => filter(button.dataset.r6ReviewFilter), { signal: controller.signal });
    filter('all');
    instances.set(section, () => controller.abort());
  }
  for (const section of scope.querySelectorAll('[data-r6-social="proof"]')) {
    if (instances.has(section)) continue;
    const controller = new AbortController();
    const track = section.querySelector('[data-r6-social-track]');
    const scroll = (direction) => {
      const card = track?.querySelector('.mte-ugc-card');
      if (!track || !card) return;
      track.scrollBy({ left: direction * (card.getBoundingClientRect().width + 14), behavior: motion.matches ? 'instant' : 'smooth' });
    };
    section.querySelector('[data-r6-social-prev]')?.addEventListener('click', () => scroll(-1), { signal: controller.signal });
    section.querySelector('[data-r6-social-next]')?.addEventListener('click', () => scroll(1), { signal: controller.signal });
    instances.set(section, () => controller.abort());
  }
  for (const section of scope.querySelectorAll('[data-r6-social="marquee"]')) {
    if (instances.has(section)) continue;
    const controller = new AbortController();
    const button = section.querySelector('[data-r6-marquee-toggle]');
    if (button) {
      button.hidden = false;
      button.addEventListener('click', () => {
        const paused = section.dataset.paused !== 'true';
        section.dataset.paused = String(paused);
        button.setAttribute('aria-pressed', String(paused));
        button.setAttribute('aria-label', paused ? 'Reanudar banda' : 'Pausar banda');
        button.textContent = paused ? '▶' : 'Ⅱ';
      }, { signal: controller.signal });
    }
    instances.set(section, () => controller.abort());
  }
}
document.addEventListener('shopify:section:load', (event) => mount(event.target));
document.addEventListener('shopify:section:unload', (event) => {
  for (const [element, destroy] of instances) if (event.target.contains(element)) { destroy(); instances.delete(element); }
});
mount();
